<template>
  <div class="buttons-rs-panel">
    <edi-round-button
      @click="shareWhatsapp"
      classes="bg-whatsapp"
      icon="fa-whatsapp"
    />
    <edi-round-button
      @click="shareFacebook"
      classes="bg-facebook"
      icon="fa-facebook-f"
    />
    <edi-round-button
      @click="shareBluesky"
      classes="bg-bluesky"
      icon="icon-bluesky"
    />
    <edi-round-button
      @click="shareTwitter"
      classes="bg-x-twitter"
      icon="icon-x"
    />
    <edi-round-button
      v-if="this.isMobile"
      @click="shareTelegram"
      classes="bg-telegram"
      icon="fa-telegram-plane"
    />
    <edi-round-button
      @click="sendMail"
      classes="bg-email"
      icon-class="fa"
      icon="fa-envelope"
    />
    <edi-round-button
      v-if="shareCommentsShow"
      @click="handlerClickComments"
      :classes="getCommentsClass"
      icon-class="fas"
      icon="fa-comments-alt"
    >
      <span
        v-if="shareCommentsNum"
        class="bg-comments__num"
      >{{shareCommentsNum}}</span>

      <edi-modal
        :show="showingModal"
        @closeModal="closeLogoutModal"
      >
        Sólo los socios/as pueden comentar.
        <a v-if="loginUrl" :href="loginUrl" @click.prevent="onClickLogin">Inicia sesión</a>
        <span v-else>Inicia sesión</span>
        o
        <a v-if="partnerUrl" :href="partnerUrl" @click.prevent="onClickSubscription">suscríbete</a>
        <span v-else>suscríbete</span>
        .
      </edi-modal>
    </edi-round-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EdiRoundButton from './EdiRoundButton.vue';
import EdiModal from '../components/EdiModal.vue';
import EdiCommentMixin from '../comments/mixins';

export default {
  name: 'edi-social-buttons',
  mixins: [EdiCommentMixin],
  components: {
    EdiModal,
    EdiRoundButton,
  },
  props: {
    pageId: String,
    shareUrl: String,
    shareText: String,
    shareTarget: String,
    shareRel: String,
    shareCommentsShow: {
      type: Boolean,
      default: false,
    },
    shareCommentsNum: {
      type: Number,
      default: 0,
    },
    isPaywall: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile: false,
      canShowModal: false,
      showingModal: false,
    };
  },
  created() {
    window.addEventListener('resize', this.mediaQuery);
    if (this.isPaywall) {
      this.canShowModal = true;
    }
  },
  mounted() {
    this.mediaQuery();
  },
  destroyed() {
    window.removeEventListener('resize', this.mediaQuery);
  },
  computed: {
    ...mapGetters([
      'loginUrl',
      'partnerUrl',
    ]),
    getCommentsClass() {
      return `bg-comments${
        this.shareCommentsShow && this.shareCommentsNum ? ' bg-comments--withcomments' : ''
      }${this.isPaywall ? ' bg-comments--in-paywall' : ''}`;
    },
  },
  methods: {
    mediaQuery() {
      this.isMobile = matchMedia('(max-width: 767px)').matches;
    },
    sendDataLayerEvent(platform) {
      const eventData = {
        method: platform,
        content_type: 'article',
        content_id: this.pageId,
      };
      window.dataLayer.push({ event: 'share', eventData });
    },
    shareTwitter() {
      this.sendDataLayerEvent('Twitter');
      let url = `https://twitter.com/intent/tweet?url=${this.shareUrl}&text=${this.shareText}`;
      if (this.shareRel) {
        url += `&via=${this.shareRel}`;
      }
      window.open(url, this.shareTarget);
    },
    shareFacebook() {
      this.sendDataLayerEvent('Facebook');
      const url = `https://www.facebook.com/sharer/sharer.php?u=${this.shareUrl}`;
      window.open(url, this.shareTarget);
    },
    shareBluesky() {
      this.sendDataLayerEvent('Bluesky');
      const url = `https://bsky.app/intent/compose?text=${this.shareText} ${this.shareUrl}`;
      window.open(url, this.shareTarget);
    },
    shareTelegram() {
      this.sendDataLayerEvent('Telegram');
      const url = `https://t.me/share/url?url=${this.shareUrl}&text=${this.shareText}`;
      window.open(url, this.shareTarget);
    },
    shareWhatsapp() {
      this.sendDataLayerEvent('WhatsApp');
      const url = `https://wa.me/?text=${this.shareText}:${this.shareUrl}`;
      window.open(url, this.shareTarget);
    },
    sendMail() {
      const url = `mailto:?Subject=Quiero que veas esta Noticia&body=${this.shareText}\n visita ${this.shareUrl}`;
      window.open(url, this.shareTarget);
    },
    handlerClickComments() {
      if (this.isPaywall) {
        this.showingModal = true;
        return;
      }

      this.scrollToComments();
    },
    closeLogoutModal() {
      this.showingModal = false;
    },
    scrollToComments() {
      const commentsArea = document.getElementById('edi-comments');
      if (commentsArea) {
        commentsArea.scrollIntoView(true);
        document.querySelector('#comment-init-btn button').click();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~sass/variables';

.edi-social-buttons .buttons-rs-panel .bg-comments--in-paywall {
  position: relative;
}

.edi-modal {
  width: 300px;
  top: -15px;
  right: 0;
  transform: translateY(-100%);
  @media #{$tablet-size} {
    width: 330px;
    right: unset; left: 26px;
  }

  &:after {
    right: 12px; bottom: -6px;
    @media #{$tablet-size} { right: auto; left: 26px; }
  }
}
</style>
